import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ documentId = '', ...params }) => {
  return await dponetAPI.get(`/document_templates/old/${documentId}`, {
    params,
  })
}

const getCategories = async () => {
  return await dponetAPI.get('/document_categories')
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/document_templates/old', data)
}

const put = async ({ documentId = '', ...data }) => {
  return await dponetAPI.put(`/document_templates/old/${documentId}`, data)
}

const destroy = async ({ documentId = '', ...data }) => {
  return await dponetAPI.delete(`/document_templates/old/${documentId}`, data)
}

const documentTemplates = {
  get,
  getCategories,
  create,
  put,
  destroy,
}

export default documentTemplates
